// document.addEventListener("DOMContentLoaded", function() {
    let navAll = document.querySelectorAll('.nav-level__item');
    let infosBlockAll = document.querySelectorAll('.infos-block');

    window.choiceYourCategory = function(e){
        e = e || window.event;
        let target = e.target;

        let sectionName = target.getAttribute('data-id');

        for(let i =0;i < navAll.length;i++){
            navAll[i].classList.remove('active');
        }

        for(let i =0;i < infosBlockAll.length;i++){
            infosBlockAll[i].classList.remove('show-block');
        }

        target.classList.add('active');

        document.querySelector('#' + sectionName).classList.add('show-block');
    }

    const sizes = {
        "tabBras":[
            {"bustCircumference":"55-57", "cup":"A", "sizeFR":"70","chestSize":"69-71"},
            {"bustCircumference":"58-62", "cup":"A", "sizeFR":"75","chestSize":"72-74"},
            {"bustCircumference":"63-67", "cup":"A", "sizeFR":"80","chestSize":"77-79"},
            {"bustCircumference":"68-72", "cup":"A", "sizeFR":"85","chestSize":"82-84"},
            {"bustCircumference":"68-72", "cup":"B", "sizeFR":"85","chestSize":"84-86"},
            {"bustCircumference":"73-77", "cup":"A", "sizeFR":"90","chestSize":"87-89"},
            {"bustCircumference":"73-77", "cup":"B", "sizeFR":"90","chestSize":"89-91"},
        ]
    };

    const empty = '';

    let resultsSizeBras = document.querySelector('#results-bras');

    let chestSize = document.querySelector('#chest-size');
    let bustCircumference = document.querySelector('#bust-circumference');

    window.createOption = function(value,domElem){
        let tmp = document.createElement('option');
        tmp.setAttribute('value', value);
        tmp.text = value;
        domElem.appendChild(tmp);
    }

    window.resetOption = function(domElem){
       var i, L = domElem.options.length - 1;
       for(i = L; i >= 0; i--) {
          domElem.remove(i);
       }
    }

    window.results = function(size,cup,domElem){
        domElem.textContent = size + " " + cup;
    }

    window.resetResults = function(domElem){
        domElem.textContent = "---";
    }

    chestSize.addEventListener('change', function () {
        let currentChest = this.value;
        let currentBust = bustCircumference.value;
        let resultCup, resultSizeFR;

        for(let i=0; i < sizes.tabBras.length; i++){
            if(currentChest !== "undefined" && sizes.tabBras[i].chestSize == currentChest && sizes.tabBras[i].bustCircumference == currentBust){
                resultCup = sizes.tabBras[i].cup;
                resultSizeFR = sizes.tabBras[i].sizeFR;
            } else{
                resetResults(resultsSizeBras);
            }
        }

        if(resultSizeFR !== "undefined" && resultCup !== "undefined"){
            results(resultSizeFR,resultCup,resultsSizeBras);
        }
    });

    bustCircumference.addEventListener('change', function () {
        let currentBust = this.value;
        let resultCup, resultSizeFR;
        resetOption(chestSize);

        for(let i=0; i < sizes.tabBras.length; i++){
            if(currentBust !== "undefined" && sizes.tabBras[i].bustCircumference == currentBust){
                createOption(sizes.tabBras[i].chestSize, chestSize);
                let currentChest = chestSize.value;
                if(sizes.tabBras[i].chestSize == currentChest){
                    resultCup = sizes.tabBras[i].cup;
                    resultSizeFR = sizes.tabBras[i].sizeFR;
                }
            }
        }

        if(resultSizeFR !== undefined && resultCup !== undefined){
            results(resultSizeFR,resultCup,resultsSizeBras);
        } else{
            resetResults(resultsSizeBras);
        }
    });

    let slideUp = (target, duration=500) => {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout( () => {
          target.style.display = 'none';
          target.style.removeProperty('height');
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
        }, duration);
      }

      let slideDown = (target, duration=500) => {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;

        if (display === 'none')
          display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout( () => {
          target.style.removeProperty('height');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
        }, duration);
      }
       let slideToggle = (target, duration = 500) => {
        target.parentNode.querySelector('.chevron-right').classList.toggle('rotate');
        if (window.getComputedStyle(target).display === 'none') {
          return slideDown(target, duration);

        } else {
          return slideUp(target, duration);
        }
      }

    let speedAnimation = 400;

    let slideBtnClick = (id, sl, targetId) => document.getElementById(id).addEventListener('click', () => sl(targetId, speedAnimation));

    slideBtnClick('slideDimGirl', slideToggle, showTabDimGirl);
    slideBtnClick('slideDimBoy', slideToggle, showTabDimBoy);

    ReadMore.init();
// });
